import { useMemo, useState } from 'react'
import styled from 'styled-components'
import { VictoryAxis, VictoryBar, VictoryChart } from 'victory'
import styles from '../../utility/styles'
import Text from '../shared/Text'

const Wrapper = styled.div`
	display: flex;
	flex-direction: column;
	flex: 1;
	align-items: center;
	@media only screen and ${styles.breakpoints.tablet} {
		& > .VictoryContainer {
			user-select: auto !important;
        	pointer-events: auto !important;
        	touch-action: auto !important;
		}
	}
`

const StyledRow = styled.div`
	display: flex;
	align-items: center;
	margin-bottom: 12px;
`

const StyledCol = styled.div``

const DaysWrapper = styled.div`
	display: flex;
	padding: 4px;
	border-radius: 8px;
	border: 2px solid ${styles.colors.lightGray};
`

const Day = styled.button`
	display: flex;
	background: ${({ isSelected }) =>
		isSelected ? styles.colors.lightGray : 'transparent'};
	border: none;
	flex: 1;
	width: 32px;
	height: 32px;
	justify-content: center;
	align-items: center;
	border-radius: 3px;
`

const StyledSvg = styled.svg`
	position: absolute;
	top: 0;
	left: 0;
	right: 0;
	height: 0;
`

const Line = styled.div`
	width: 24px;
	height: 3px;
	border-radius: 1.5px;
	background-color: ${styles.colors.blue};
	margin-right: 12px;
`

export default function PopularTimesChart({ popularTimes = [] }) {
	const [day, setDay] = useState(new Date().getDay())
	const hour = useMemo(() => Math.floor(new Date().getHours() / 2), [])
	const selected = useMemo(
		() => popularTimes?.find(thing => thing.day === day),
		[day, popularTimes]
	)
	const data = useMemo(() => {
		if (typeof selected?.vals !== 'object') return []
		const arr = Object.values(selected.vals)
		const squished = arr
			.map((el, i) => i % 2 !== 0 && Math.round((el + arr[i - 1]) / 2))
			.filter(el => el !== false)
		return squished
	}, [selected])

	return (
		<Wrapper>
			<StyledSvg>
				<linearGradient id='gradient' x1='0' x2='0' y1='0' y2='100%'>
					<stop
						offset='0#%'
						stopColor={styles.colors.blue}
						stopOpacity={0.4}
					/>
					<stop
						offset='100%'
						stopColor={styles.colors.blue}
						stopOpacity={0.05}
					/>
				</linearGradient>
				<linearGradient id='gradientCurrent' x1='0' x2='0' y1='0' y2='100%'>
					<stop
						offset='0#%'
						stopColor={styles.colors.blue}
						stopOpacity={1}
					/>
					<stop
						offset='100%'
						stopColor={styles.colors.blue}
						stopOpacity={0.1}
					/>
				</linearGradient>
			</StyledSvg>
			<VictoryChart domainPadding={{ x: 25 }}>
				<VictoryAxis
					style={{
						axis: {
							stroke: styles.colors.white,
							strokeWidth: 2,
						},
					}}
				/>
                <VictoryAxis
					dependentAxis
					tickFormat={t => `${t}%`}
					style={{
						tickLabels: {
							opacity: 1,
							fill: styles.colors.lightGray,
						},
						ticks: { opacity: 0 },
						axis: { opacity: 0 },
						grid: {
							stroke: styles.colors.lightGray,
							strokeWidth: 1.5,
							strokeDasharray: [5, 5]
						},
					}}
				/>
				<VictoryBar
                    animate
					{...{ data }}
					barRatio={1}
					alignment='start'
					style={{
						data: {
							fill: ({ index }) => hour === index + 1 ? 'url(#gradientCurrent)' : 'url(#gradient)'
						},
					}}
				/>
			</VictoryChart>
			<StyledRow>
				<Line />
				<Text.Tiny variant='bold'>Station Utilization</Text.Tiny>
			</StyledRow>
			<DaysWrapper>
				{['M', 'T', 'W', 'Th', 'F', 'Sa', 'Su'].map((d, i) => (
					<Day
						key={d}
						isSelected={day === i + 1}
						onClick={() => setDay(i + 1)}
					>
						<Text.Tiny
							variant='bold'
							color={
								day === i + 1
									? styles.colors.background
									: styles.colors.lightGray
							}
						>
							{d}
						</Text.Tiny>
					</Day>
				))}
			</DaysWrapper>
		</Wrapper>
	)
}
